import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import meme from 'assets/dashboard/meme.png';
import spotlight from 'assets/dashboard/spotlights.png';

import MemesDashboard from './memes';
import SpotlightDashboard from './spotlights';

export const SOCIAL_RESOURCES = {
	memes: 'memes',
	spotlights: 'spotlights'
};

export const URL = {
	[SOCIAL_RESOURCES.memes]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.social}/${SOCIAL_RESOURCES.memes}`,
	[SOCIAL_RESOURCES.spotlights]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.social}/${SOCIAL_RESOURCES.spotlights}`
};

export const LABEL = {
	[SOCIAL_RESOURCES.memes]: 'Memes',
	[SOCIAL_RESOURCES.spotlights]: 'Spotlights'
};

export const COMPONENT = {
	[SOCIAL_RESOURCES.memes]: MemesDashboard,
	[SOCIAL_RESOURCES.spotlights]: SpotlightDashboard
};

export const GET_ACTION = {
	[SOCIAL_RESOURCES.memes]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.social].getAllMemePosts,
	[SOCIAL_RESOURCES.spotlights]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.social].listContent
};

export const IMAGE_SOURCE = {
	[SOCIAL_RESOURCES.memes]: meme,
	[SOCIAL_RESOURCES.spotlights]: spotlight
};
